<template>
  <ChartTitleWrapper :title="title">
    <VueApexCharts type="bar" :height="350" :options="chartOptions" :series="series" />
  </ChartTitleWrapper>
</template>

<script setup>
import { computed } from "vue";
import VueApexCharts from "vue3-apexcharts";

import { getChartOptions } from "@/app/reports/utils/chart";

import ChartTitleWrapper from "@/app/reports/components/charts/ChartTitleWrapper.vue";

const props = defineProps({
  title: String,
  data: Array,
});

const chartOptions = getChartOptions({
  xAxis: {
    title: "Tipo de llamadas",
    categories: [
      "Llamadas recibidas",
      "Llamadas atendidas",
      "Llamadas del NS",
      "Llamadas abandonadas",
    ],
  },
  yAxis: {
    title: "Cantidad de llamadas",
  },
  chartColors: ["#D9F7BE", "#FFE58F", "#FFA39E", "#91D5FF"],
  singleBar: true,
  legend: {
    show: false,
  },
});

const series = computed(() => [
  {
    name: "",
    data: [
      props.data?.[0]?.recibida_mes || null,
      props.data?.[0]?.atendidas_mes || null,
      props.data?.[0]?.atendidas30_mes || null,
      props.data?.[0]?.abandonadas_mes || null,
    ],
  },
]);
</script>

<style lang="sass" scoped>
h3
  font-size: 16px
  font-weight: 600
  margin: 35px 0 12px 0
  text-align: center
</style>
